import React, { useState } from 'react';
import { FailedListPage } from './FailedListPage';
import { Button } from '../../../../../components';
import { FAILED_LIST_BUTTON, failedListFiltersMap } from './const';

export const FailedList: React.FunctionComponent = () => {
  const [activateButton, setActivateButton] = useState<FAILED_LIST_BUTTON>(
    FAILED_LIST_BUTTON.ALL,
  );

  const handleChangeFilterButton = (button: FAILED_LIST_BUTTON) => () => {
    setActivateButton(button);
  };

  const buttonArea: React.ReactNode = (
    <div className="flex flex-row">
      {Object.keys(FAILED_LIST_BUTTON)?.map((item, index) => {
        return (
          <div key={index} className="mr-4">
            <Button
              sx={{ textTransform: 'none' }}
              onClick={handleChangeFilterButton(item as FAILED_LIST_BUTTON)}
              variant={activateButton === item ? 'contained' : 'outlined'}
            >
              {failedListFiltersMap[item as FAILED_LIST_BUTTON]?.label}
            </Button>
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      <FailedListPage
        key={activateButton}
        activateButton={activateButton}
        filter={failedListFiltersMap[activateButton]?.filter}
      >
        {buttonArea}
      </FailedListPage>
    </>
  );
};
